import { render, staticRenderFns } from "./PayBack.vue?vue&type=template&id=336d282b&scoped=true&"
import script from "./PayBack.vue?vue&type=script&lang=js&"
export * from "./PayBack.vue?vue&type=script&lang=js&"
import style0 from "./PayBack.vue?vue&type=style&index=0&id=336d282b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336d282b",
  null
  
)

export default component.exports